<template>
  <div class="sub-page">
    <div class="sub-tab-wrap">
      <DxTabPanel
        id="tabpanel"
        :selected-index.sync="selectedIndex"
        :data-source="tabs"
        :focusStateEnabled="true"
        @titleClick="onSelectedVendor"
      >
        <template #title="{ data: tab }">
          <div class="sub-title-wrap-tab">
            <ul>
              <li class="float-left sub-title">{{ tab.거래처명 }}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class="sub-content">
      <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="grid-wrap">
        <dx-data-grid
          ref="refInventoryGrid"
          :data-source="inventoryReceiptInfo"
          :show-borders="true"
          :showRowLines="false"
          :showColumnLines="true"
          :hover-state-enabled="true"
          :allowColumnResizing="true"
          column-resizing-mode="widget"
          :allow-column-reordering="true"
          :height="gridHeight"
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="true"
          :focused-row-key.sync="focusedRowKey"
          key-expr="seqId"
          @toolbar-preparing="onToolbarPreparing"
          @cell-prepared="onCellPreparedOutput"
          @row-removed="onRowRemoved"
          @row-removing="onRowRemoving"
          @row-inserted="onRowInserted"
          @row-inserting="onRowInserting"
          @row-updated="onRowUpdated"
          @row-updating="onRowUpdating"
          @editor-preparing="onEditorPreparing"
          @rowPrepared="onRowPrepared"
          @init-new-row="onInitNewRow"
          @focused-row-changed="onSelectionChanged"
        >
          <DxSearchPanel :visible="true" placeholder="검색..." />
          <DxExport :enabled="true" :file-name="exportTitle" />
          <DxEditing
            :allow-deleting="(userInfo.permission & crudAllow) > 0"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="false"
            :use-icons="true"
            mode="raw"
          >
          </DxEditing>
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxColumnFixing :enabled="true" />
          <DxStateStoring
            :enabled="false"
            type="localStorage"
            storage-key="storage"
          />
          <DxColumn
            :allowEditing="isIdEdit"
            :fixed="false"
            caption="입고일"
            data-field="발생일자"
            dataType="date"
            format="yyyy-MM-dd"
            :editor-options="issueDateOption"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>

          <DxColumn
            :allowEditing="true"
            caption="고객사"
            data-field="입고업체"
          >
            <DxLookup
              :data-source="companyInfoLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :caption="$store.getters.getGroupName"
            data-field="차종"
            :visible="true"
            width="60"
          >
            <DxLookup
              :data-source="carTypeLookup"
              display-expr="모델코드"
              value-expr="모델코드"
            />
          </DxColumn>

          <DxColumn
            :allowEditing="isIdEdit"
            :fixed="false"
            caption="품번"
            data-field="품번"
            edit-cell-template="coilGridTemplate"
            width="110"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="품명"
            data-field="품명"
            :visible="true"
            width="190"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :fixed="false"
            caption="재질"
            data-field="재질"
            :visible="true"
            width="130"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :fixed="false"
            caption="두께"
            data-field="자사두께"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="가로"
            data-field="자사가로"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="세로"
            data-field="자사세로"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="중량"
            data-field="수량"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="코일수"
            data-field="코일수"
            :visible="true"
            format="#,##0"
            dataType="number"
            width="60"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="LOT_NO"
            data-field="lotNo"
            :visible="true"
            width="150"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="구매단가"
            data-field="가격"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="운반비"
            data-field="운반비"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
           <DxColumn
            :allowEditing="false"
            caption="구매금액"
            data-field="구매금액"
            :calculate-cell-value="calcAmount"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩처리"
            data-field="스크랩처리"
            :visible="true"
            width="80"
          >
            <DxLookup
              :data-source="scrapLookup"
              display-expr="코드명"
              value-expr="코드명"
            />
          </DxColumn>
           <DxColumn
            :allowEditing="true"
            :fixed="false"
            caption="마감월"
            data-field="마감일자"
            dataType="date"
            format="yyyy-MM"
            width="80"
            :editor-options="{calendarOptions: {maxZoomLevel: 'year', minZoomLevel: 'century'}}"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="NO"
            data-field="seqId"
            width="50"
            sort-order="desc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="구분"
            data-field="자작"
            width="50"
          >
          </DxColumn>
          <!-- <DxColumn
            :allowEditing="false"
            caption="입출구분"
            data-field="입출고구분"
            :visible="true"
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn> -->
          <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="그룹번호"
            data-field="발주번호"
            width="50"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="재질품번"
            data-field="재질품번"
            width="50"
          >
          </DxColumn>

          <DxColumn width="90" :buttons="editSubButtons" type="buttons" />
          <!-- <DxColumn
            type="buttons"
            :width="90"
          >
            <DxButton name="edit"/>
            <DxButton name="delete"/>
            <DxButton
              hint="Clone"
              icon="clear"
              :visible="isDeletableFlag"
              @click="onClickRegBadCoil()"
            />
          </DxColumn> -->
          <DxSummary>
            <DxTotalItem
              value-format="#,##0"
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format="#,##0"
              summary-type="sum"
              column="수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format="#,##0"
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false" />
          <dx-scrolling
            mode="virtual"
            showScrollbar="always"
            :useNative="false"
          />
          <dx-sorting mode="multiple" />
          <template #coilGridTemplate="{ data: cellInfo }">
            <CoilGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-pcode="setCoilCode"
              :productionInfo="coilInfoList"
            />
          </template>
        </dx-data-grid>
      </div>
      <DxPopupGen v-if="popupBadColi"
        :visible.sync="popupBadColi"
        :width="600"
        :height="220"
        title="원자재 불량 처리"
      >
        <div>
          <DxForm2
            ref="refFormBasCoil"
            id="form"
            :col-count="2"
            :form-data.sync="editBadCoilOrgInfo"
          >
            <DxItem
              data-field="차종"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            />
            <DxItem
              data-field="품번"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="코일수"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="입고중량"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="불량구분"
              editor-type="dxSelectBox"
              :editor-options = "badCauseOption"
            >
              <dx-required-rule message="항목을 선택하세요"/>
            </DxItem>
            <DxItem
              data-field="불량중량"
              editor-type="dxNumberBox"
              :editor-options ="{ showClearButton: true}"
            >
              <dx-required-rule message="항목을 입력하세요"/>
            </DxItem>
            <DxEmptyItem />
            <DxEmptyItem />
            <DxButtonItem
              :col-span="2"
              :button-options="buttonOptions"
              horizontal-alignment="right"
            />
          </DxForm2>
        </div>
      </DxPopupGen>
      <DxPopupGen v-if="popupChangeCoilSize"
        :visible.sync="popupChangeCoilSize"
        :width="600"
        :height="260"
        title="원자재 용도 변경"
      >
        <div>
          <DxForm2
            ref="refFormCoilSizeChange"
            id="form"
            :col-count="2"
            :form-data.sync="editCoilSizeChangeInfo"
          >
            <DxItem
              data-field="차종"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            />
            <DxItem
              data-field="품번"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="재질"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="두께"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="코일수"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="입고중량"
              editor-type="dxTextBox"
              :editor-options ="{ disabled: true}"
            >
            </DxItem>
            <DxItem
              data-field="용변품번"
              template="coilChSizeGridTemplate"
            >
               <dx-required-rule message="항목을 선택하세요"/>
            </DxItem>
            <DxItem
              data-field="용변중량"
              editor-type="dxNumberBox"
              :editor-options ="{ showClearButton: true}"
            >
              <dx-required-rule message="항목을 입력하세요"/>
            </DxItem>
            <DxEmptyItem />
            <DxEmptyItem />
            <DxButtonItem
              :col-span="2"
              :button-options="buttonOptionsSizeChange"
              horizontal-alignment="right"
            />
            <template #coilChSizeGridTemplate="{ data: cellInfo }">
              <CoilGridComponent
                :value="cellInfo.value"
                :on-value-changed="cellInfo.setValue"
                @selected-pcode="setCoilCode"
                :productionInfo="coilInfoList"
              />
            </template>
          </DxForm2>
        </div>
      </DxPopupGen>
      <loading
        :active.sync="isLoading"
        color="rgb(2, 110, 156)"
        loader="bars"
      ></loading>
    </div>
    <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxFilterRow,
  DxColumnFixing,
  DxTotalItem,
  DxLookup,
  DxSummary,
  DxColumn,
  DxPaging,
  DxSorting,
  DxSearchPanel,
  DxExport,
  DxEditing,
  DxStateStoring
} from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import { DxForm as DxForm2, DxItem, DxButtonItem, DxEmptyItem } from 'devextreme-vue/form'
import CoilGridComponent from '../../share/component/CoilGridComponent'
import axios from 'axios'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      crudAllow: ConstDef.CRUD_ALLOW_구매,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '제품출하현황'
        }
      ],
      editSubButtons: null,
      inventoryReceiptInfo: [],
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      selectedVendor: null,
      processingTypeLookup: null,
      meterialTypeLookup: null,
      coilInfoList: null,
      외주사급코일정보: null,
      selectedCoilCode: null,
      companyInfoLookup: null,
      scrapLookup: null,
      isScarpInput: false,
      isIdEdit: true,
      carTypeLookup: null,
      maxSeqId: null,
      scrapPrice: null,
      coilInputBtn: null,
      scrapInputBtn: null,
      showCompleted: false,
      isDeletableFlag: true,
      is마감: false,
      issueDateOption: null,
      scrapPriceAll: null,
      // 불량코일 처리
      popupBadColi: false,
      buttonOptions: {
        text: '저장',
        width: 120,
        type: 'default',
        onClick: (args) => {
          this.onSaveBadCoil()
        }
      },
      editBadCoilOrgInfo: null,
      badCauseOption: null,
      // 용도변경
      popupChangeCoilSize: false,
      editCoilSizeChangeInfo: null,
      buttonOptionsSizeChange: {
        text: '용도변경',
        width: 120,
        type: 'default',
        onClick: (args) => {
          this.onChangeCoilSize()
        }
      }
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxStateStoring,
    DxPopupGen,
    DxForm2,
    DxItem,
    DxButtonItem,
    DxEmptyItem,
    CoilGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ year: i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ name: i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ name: i + '월', value: '' + i })
      }
    }
    this.issueDateOption = { calendarOptions: { min: `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01` } }
    this.scrapLookup = ConstDef.SCRAP_LOOKUP
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.자재유형
    )
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.공정유형
    )
    this.receiptTypeLookup = ConstDef.COIL_INOUT_CODE
    console.log(this.receiptTypeLookup)
    this.companyInfoLookup = this.$_.sortBy(
      this.$store.getters.getFirstVendor,
      '거래처명'
    )
    this.companyInfoLookup.push({
      거래처명: '시중구매',
      거래처코드: '시중구매'
    })
    this.editSubButtons = ['edit', 'delete',
      {
        hint: '코일불량처리',
        icon: 'clear',
        visible: (this.userInfo.permission & this.crudAllow) > 0,
        onClick: (args) => { this.onClickRegBadCoil(args) }
      }
    ]

    this.badCauseOption = {
      items: ConstDef.BAD_COIL_CAUSE,
      valueExpr: '코드명',
      displayExpr: '코드명'
    }
    this.refreshScrapPriceAll()
    this.refreshCoilInfo()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {},
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      return row.수량 * (row.가격 + row.운반비)
    },
    checkScrapEditable (e) {
      console.log(e)
      return this.isScarpInput
    },
    isEditableDeletable (row) {
      if (typeof row.row.data.발생일자 === 'object') {
        return
      }
      this.isDeletableFlag = AppLib.isInOutCRUDable(row.row.data.발생일자)
      if (this.showCompleted) {
        return false
      }
      return this.isDeletableFlag
    },
    isAddable () {
      // const result = AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
      this.isDeletableFlag = AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
      setTimeout(() => {
        this.coilInputBtn.option({ disabled: !this.isDeletableFlag })
        this.scrapInputBtn.option({ disabled: !this.isDeletableFlag })
      }, 100)
    },
    isQtyEditable () {
      return AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.type === 'buttons') {
        if (AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`) && !this.showCompleted) {
          // this.$Q(e.cellElement).show()
          this.$Q('.dx-link-delete').show()
          this.$Q('.dx-link-edit').show()
        } else {
          this.$Q('.dx-link-delete').hide()
        }
      }
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (
          e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드
        ) {
          // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
      if (
        e.rowType === 'data' &&
        e.column.type !== undefined &&
        e.column.type === 'buttons'
      ) {
        if (e.data.사용유무) {
          this.$Q(e.cellElement)
            .find('.dx-icon-showpanel')
            .hide()
        }
      }
    },
    onClickRegBadCoil (e) {
      console.log(e.row.data)
      // if (!AppLib.isInOutCRUDable(e.row.data.발생일자)) {
      //   this.$snotify.warning('마감 완료된 월은 수정할 수 없습니다.')
      //   return
      // }
      if (e.row.data.품번 === 'SCRAP') {
        this.$snotify.warning('스크랩은 불량처리 할 수 없습니다.')
        return
      }
      if (e.row.data.스크랩처리 === '보관불량') {
        this.$snotify.warning('전체 또는 일부 중량 보간불량 처리되어 있습니다.')
      }
      if (e.row.data.입출고구분 === ConstDef.용변출고) {
        this.$snotify.warning('용변출고 항목은 불량처리 할 수 없습니다.')
        return
      }
      this.editBadCoilOrgInfo = {}
      this.editBadCoilOrgInfo.차종 = this.selectedRow.차종
      this.editBadCoilOrgInfo.품번 = this.selectedRow.품번
      this.editBadCoilOrgInfo.입고중량 = this.selectedRow.수량
      this.editBadCoilOrgInfo.코일수 = this.selectedRow.코일수
      this.editBadCoilOrgInfo.불량중량 = null
      this.editBadCoilOrgInfo.불량구분 = null
      this.popupBadColi = true
    },
    onInitNewRow (row) {
      console.log(this.selectedVendor)
      if (this.selectedVendor !== 'ALL') {
        row.data.입고업체 = this.selectedVendor
      }
      const thisMonth = AppLib.getToday().substring(0, 7)
      console.log(thisMonth)
      if (thisMonth !== `${this.thisYear}-${this.thisMonth}`) {
        row.data.발생일자 = AppLib.getMonthLastDateByDate(`${this.thisYear}-${this.thisMonth}`) + ' ' + this.$store.getters.getSysParamByKey('재고관리기준시간')
      } else {
        row.data.발생일자 = `${AppLib.getToday()} ${this.$store.getters.getSysParamByKey('재고관리기준시간')}`
      }
      console.log(row.data.발생일자)
      row.data.마감일자 = row.data.발생일자
      console.log(row.data.마감일자)
      row.data.입출고구분 = ConstDef.자재입고
      row.data.운반비 = 0
      row.data.사용유무 = true
      this.isIdEdit = true
    },
    onEditorPreparing (e) {
      if (e.dataField === 'lotNo' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
        console.log(this.isIdEdit)
      }
    },
    onRowPrepared (e) {},
    onRowInserted (row) {
      console.log(row.data)
      const coilInfo = this.$_.findWhere(this.coilInfoList, {
        품번: row.data.품번
      })
      console.log(coilInfo)
      row.data.재질 = coilInfo.재질
      row.data.가격 = coilInfo.가격
      row.data.품명 = coilInfo.품명
      console.log(row.data)

      if (row.data.발생일자 !== null && typeof row.data.발생일자 === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      const isSagup = this.$_.findWhere(this.외주사급코일정보, { 품번: row.data.품번 }) !== undefined
      const param = {
        발생일자: row.data.발생일자,
        마감일자: row.data.마감일자,
        입고업체: row.data.입고업체,
        입출고구분: row.data.입출고구분,
        품번: row.data.품번,
        수량: row.data.수량,
        코일수: row.data.코일수,
        운반비: row.data.운반비,
        단가: row.data.가격,
        구입가: row.data.가격,
        발주번호: AppLib.uuidSequential(),
        lotNo: null,
        createid: this.userInfo.userName,
        updateid: this.userInfo.userName,
        재질품번: row.data.품번,
        사용유무: isSagup
      }
      if (row.data.lotNo !== undefined) {
        param.lotNo = row.data.lotNo
      }
      if (this.isScarpInput) {
        if (row.data.lotNo === undefined) {
          row.data.lotNo = ''
        }
        param.스크랩처리 = row.data.스크랩처리
        row.data.품번 = param.품번 = 'SCRAP'
        // row.data.lotNo += `(${row.data.재질})`
        param.lotNo = row.data.lotNo
      }
      this.$_sp.runInsertAndFindSqlProc('창고수불', ['발주번호'], ['자사두께', '자사가로', '자사세로'], param)
        .then(data => {
          // console.log(this.$_sp.MakeModel(data))
          this.focusedRowKey = this.$_sp.MakeModel(data)[0].seqId
          // this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`, false)
          this.refreshInventoryList()
          if (isSagup) {
            this.insertOutputInfo(isSagup, coilInfo, param)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // 사급출고
    insertOutputInfo (isSagup, coilInfo, param) {
      console.log(coilInfo)
      if (!isSagup) return
      if (param.스크랩처리 === '재활용') return
      param.입출고구분 = ConstDef.사급출고
      param.입고업체 = coilInfo.협력사코드
      this.$_sp.runInsertSqlProc('창고수불', ['규격', '운반비'], [param])
        .then(data => {})
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {
      if (row.data.발생일자 !== null && typeof row.data.발생일자 === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      if (row.data.마감일자 !== null && typeof row.data.마감일자 === 'object') {
        row.data.마감일자 = row.data.마감일자.getTime()
      }
      if (!AppLib.isInOutCRUDable(row.data.발생일자)) {
        this.$snotify.info('전전월로 입고처리 할 수 없습니다.')
        row.cancel = true
      }
      if (!AppLib.isInOutCRUDable(row.data.마감일자)) {
        this.$snotify.info('전전월로 마감처리 할 수 없습니다.')
        row.cancel = true
      }
      if (row.data.입고업체 === ConstDef.시중구매 && !this.isScarpInput) {
        if (row.data.가격 === 0) {
          this.$snotify.info('시중구매시 구매단가를 입력하여 주세요.')
          row.cancel = true
        }
      }
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp
        .runDeleteSqlProc('창고수불', [{ 발주번호: row.data.발주번호 }])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (row) {
      const 재고관리기준시간 = this.$store.getters.getSysParamByKey(
        '재고관리기준시간'
      )
      console.log(재고관리기준시간)
      if (AppLib.isLessThisMonth(`${재고관리기준시간}:00`, row.data.발생일자)) {
        this.$snotify.info('전월 입고는 마감되어 삭제할 수 없습니다.')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      let 구입가 = 0
      console.log(row.data)
      if (row.data.입고업체 === ConstDef.시중구매) {
        구입가 = row.data.가격
      }
      const param = [
        {
          입고업체: row.data.입고업체,
          발주번호: row.data.발주번호,
          발생일자: row.data.발생일자,
          수량: row.data.수량,
          입출고구분: ConstDef.자재입고,
          코일수: row.data.코일수,
          운반비: row.data.운반비,
          구입가: 구입가,
          lotNo: row.data.lotNo,
          스크랩처리: row.data.스크랩처리,
          updatetime: row.data.updatetime,
          updateid: row.data.updateid
        }
      ]
      const paramOut = [
        {
          발주번호: row.data.발주번호,
          발생일자: row.data.발생일자,
          수량: row.data.수량,
          입출고구분: ConstDef.사급출고,
          코일수: row.data.코일수,
          구입가: 구입가,
          lotNo: row.data.lotNo,
          스크랩처리: row.data.스크랩처리,
          updatetime: row.data.updatetime,
          updateid: row.data.updateid
        }
      ]
      const inProc = this.$_sp.runUpdateSqlProc('창고수불', ['발주번호', '입출고구분'], null, param)
      const outProc = this.$_sp.runUpdateSqlProc('창고수불', ['발주번호', '입출고구분'], null, paramOut)
      axios.all([inProc, outProc])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
          this.refreshInventoryList()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      let firstDay = `${AppLib.getToday().substring(0, 7)}-01 00:00:00`
      firstDay = AppLib.getTimestampFromString(firstDay)
      if (row.newData.발생일자 !== undefined) {
        if (row.newData.발생일자 < firstDay) {
          this.$snotify.info('발생일자는 전월로 변경할 수 없습니다.')
          row.cancel = true
        }
      }
      if (row.newData.마감일자 !== undefined) {
        this.$_sp
          .runUpdateSqlProc('창고수불', ['seqId'], null, [
            { seqId: row.oldData.seqId, 마감일자: row.newData.마감일자 }
          ])
          .then(data => {
            console.log(`마감일자 수정 ${row.newData.마감일자}`)
          })
      }
      if (row.newData.가격 !== undefined && (row.newData.가격 === 0 || row.newData.가격 === null)) {
        if (row.newData.입고업체 === ConstDef.시중구매) {
          this.$snotify.info('시중구매시 구매단가를 입력하여 주세요.')
          row.cancel = true
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: args => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.isAddable()
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`, false)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: args => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.isAddable()
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`, false)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          widget: 'dxCheckBox',
          options: {
            value: this.showCompleted,
            text: '선택월 마감자료',
            onValueChanged: args => {
              this.showCompleted = args.value
              this.refreshInventoryList()
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`, this.showCompleted)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '코일 입고',
            icon: 'add',
            text: '코일 입고',
            type: 'success',
            focusStateEnabled: true,
            visible: (this.userInfo.permission & this.crudAllow) > 0,
            onInitialized: args => {
              this.coilInputBtn = args.component
            },
            onClick: args => {
              this.isScarpInput = false
              this.focusedRowKey = this.maxSeqId
              setTimeout(() => {
                this.$refs.refInventoryGrid.instance.addRow()
              }, 500)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '스크랩 입고',
            icon: 'add',
            text: '스크랩입고',
            type: 'default',
            visible: (this.userInfo.permission & this.crudAllow) > 0,
            focusStateEnabled: true,
            onInitialized: args => {
              this.scrapInputBtn = args.component
            },
            onClick: args => {
              this.isScarpInput = true
              this.focusedRowKey = this.maxSeqId
              setTimeout(() => {
                this.$refs.refInventoryGrid.instance.addRow()
              }, 500)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '코일 용도변경',
            icon: 'edit',
            text: '용도변경',
            type: 'danger',
            visible: (this.userInfo.permission & this.crudAllow) > 0,
            focusStateEnabled: true,
            onClick: args => {
              if (this.selectedRow === null) {
                this.$snotify.info('용도변경할 품목을 선택하여 주세요.')
                return
              }
              this.popupChangeCoilSize = true
              this.editCoilSizeChangeInfo = {}
              this.editCoilSizeChangeInfo.차종 = this.selectedRow.차종
              this.editCoilSizeChangeInfo.품번 = this.selectedRow.품번
              this.editCoilSizeChangeInfo.입고중량 = this.selectedRow.수량
              this.editCoilSizeChangeInfo.코일수 = this.selectedRow.코일수
              this.editCoilSizeChangeInfo.재질 = this.selectedRow.재질
              this.editCoilSizeChangeInfo.두께 = this.selectedRow.자사두께
              this.editCoilSizeChangeInfo.용변품번 = null
              this.editCoilSizeChangeInfo.용변중량 = null
            }
          }
        }
      )
    },
    searchEmptyPressSize (coilInfo) {
      const where = this.$_.where(coilInfo, { 자사두께: null })
      console.log(where)
      let param = null
      where.forEach(item => {
        param = {
          품번: item.품번
        }
        if (item.품번 === 'SCRAP') {
          param.품번 = item.재질품번
        }
        this.$_sp
          .runNoEncodeFindProc('spFindAllPressSizeByCoilCode', param)
          .then(data => {
            const result = this.$_sp.MakeModel(data)
            if (result.length > 0) {
              item.자사두께 = result[0].자사두께
              item.자사가로 = result[0].자사가로
              item.자사세로 = result[0].자사세로
            }
          })
      })
    },
    makeCarModelLookup () {
      const model = this.$_.uniq(this.inventoryReceiptInfo, item => item.차종)
      this.carTypeLookup = []
      model.forEach(item => {
        if (item.차종 !== null) {
          this.carTypeLookup.push({
            모델코드: item.차종
          })
        }
      })
      this.carTypeLookup = this.$_.sortBy(this.carTypeLookup, '모델코드')
    },
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      console.log(this.selectedVendor)
      this.refreshInventoryList()
    },
    refreshCoilInfo () {
      // spFindAllCoilInfo
      const coil = this.$_sp.runNoEncodeFindProc('spFindAllCoilInfo', { 기준일: `${this.thisYear}=${this.thisMonth}-01` })
      const sagup = this.$_sp.runNoEncodeFindProc('spFindAll외주품CoilInfo', { 기준일: `${this.thisYear}=${this.thisMonth}-01` })
      axios.all([coil, sagup])
        .then(axios.spread((...reponse) => {
          this.coilInfoList = this.$_sp.MakeModel(reponse[0])
          // console.log(this.coilInfoList)
          this.외주사급코일정보 = this.$_sp.MakeModel(reponse[1])
          // console.log(this.외주사급코일정보)
          const index = this.$_.findIndex(this.coilInfoList, { 품번: 'SCRAP' })
          console.log(index)
          if (index > 0) {
            this.scrapPrice = this.coilInfoList[index].가격
            this.coilInfoList.splice(index, 1)
          }
          // this.searchEmptyPressSize(this.coilInfoList)
          this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`, false)
        }))
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-원자재수불`
      this.isLoading = true
      let endDate = `${this.thisYear}-${
        this.thisMonth
      }-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01`,
        endDate: `${endDate}`,
        품목유형: ConstDef.구매품,
        자재유형: ConstDef.자재유형_원자재,
        거래처코드: this.selectedVendor,
        마감: 0
      }
      if (this.showCompleted) {
        param.마감 = 1
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
        .then(data => {
          this.isLoading = false
          this.inventoryReceiptInfo = this.$_sp.MakeModel(data)
            .filter(item =>
              item.입출고구분 === ConstDef.자재입고
            )
          console.log(this.inventoryReceiptInfo)
          const where = this.$_.where(this.inventoryReceiptInfo, {
            품번: 'SCRAP'
          })
          where.forEach(item => {
            let where = this.$_.find(this.scrapPriceAll, function (price) {
              return price.적용일자 <= item.발생일자 && price.만료일자 > item.발생일자
            })
            item.가격 = where.가격
          })
          const max = this.$_.max(this.inventoryReceiptInfo, function (item) {
            return item.seqId
          })
          this.maxSeqId = max.seqId
          if (this.focusedRowKey === null) {
            this.focusedRowKey = max.seqId
          }
          // this.searchEmptyPressSize(this.inventoryReceiptInfo)
          this.makeCarModelLookup()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPriceAll () {
      this.$_sp.runNoEncodeFindSqlProc('스크랩코일가격', { 재질: 'SCRAP' })
        .then(data => {
          this.scrapPriceAll = this.$_sp.MakeModel(data)
          console.log(this.scrapPriceAll)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshVendorList (date, is마감) {
      let callProc
      const param = {
        toDate: `${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`,
        fromDate: `${date}-01`,
        자재유형: ConstDef.자재유형_원자재,
        입출고구분: ConstDef.자재입고
      }
      if (is마감) {
        callProc = this.$_sp.runNoEncodeFindProc('spFindAllDeadLineInputVendorListByDate', param)
      } else {
        callProc = this.$_sp.runNoEncodeFindProc('spFindAllInputVendorList', param)
      }
      callProc
        .then(data => {
          this.tabs = this.$_sp.MakeModel(data)
          // console.log(this.tabs)
          this.tabs.unshift({ 거래처명: 'ALL', 입고업체: 'ALL' })
          if (this.selectedVendor == null || (this.selectedVendor !== null && this.$_.findIndex(this.tabs, { 입고업체: this.selectedVendor }) < 0)) {
            this.selectedVendor = 'ALL'
            this.selectedIndex = 0
          } else {
            this.selectedIndex = this.$_.findIndex(this.tabs, { 입고업체: this.selectedVendor })
          }
          this.refreshInventoryList()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // set emit
    setCoilCode (code) {
      // console.log(code)
      this.selectedCoilCode = code
    },
    // 코일 불량 처리 저장
    badCoilPrecessing () {
      if (this.editBadCoilOrgInfo.불량구분 === '보관불량') {
        this.storeBadProcessing()
        return
      }
      const diffInput = this.selectedRow.수량 - this.editBadCoilOrgInfo.불량중량
      console.log(diffInput)
      this.selectedRow.수량 = diffInput
      this.selectedRow.lotNo = `${this.selectedRow.lotNo === null ? '' : this.selectedRow.lotNo} NO: ${this.selectedRow.seqId} ${this.editBadCoilOrgInfo.불량중량}kg 불량처리`

      let badCoil = {} // this.$Q.extend(true, {}, this.selectedRow)
      badCoil.품번 = 'SCRAP'
      badCoil.스크랩처리 = this.editBadCoilOrgInfo.불량구분
      badCoil.발생일자 = this.selectedRow.발생일자
      badCoil.수량 = this.editBadCoilOrgInfo.불량중량
      badCoil.코일수 = this.selectedRow.코일수
      badCoil.운반비 = 0
      badCoil.구매구분 = this.selectedRow.구매구분
      badCoil.입고업체 = this.selectedRow.입고업체
      badCoil.발주번호 = AppLib.uuidSequential()
      badCoil.입출고구분 = this.selectedRow.입출고구분
      badCoil.입고키 = this.selectedRow.입고키
      badCoil.lotNo = this.selectedRow.lotNo
      badCoil.재질품번 = this.selectedRow.재질품번
      badCoil.사용유무 = this.selectedRow.사용유무
      badCoil.구입가 = this.selectedRow.구입가
      badCoil.판매가 = this.selectedRow.판매가
      // console.log(badCoil)
      let sakupBad = null
      if (this.$_.findWhere(this.외주사급코일정보, { 품번: this.selectedRow.품번 }) !== undefined) {
        const param = this.$Q.extend(true, {}, badCoil)
        param.입출고구분 = ConstDef.사급출고
        param.입고업체 = this.$_.findWhere(this.coilInfoList, { 품번: this.selectedRow.품번 }).협력사코드
        sakupBad = this.$_sp.runInsertSqlProc('창고수불', null, [param])
      }
      const inCoil = this.$_sp.runUpdateSqlProc('창고수불', ['발주번호'], null,
        [{ 발주번호: this.selectedRow.발주번호, 수량: this.selectedRow.수량, lotNo: this.selectedRow.lotNo }])
      const badCoilSp = this.$_sp.runInsertAndFindSqlProc('창고수불', ['발주번호', '수량', '품번', '입출고구분'], ['seqId'], badCoil)
      axios.all([inCoil, badCoilSp, sakupBad])
        .then(axios.spread((...response) => {
          const temp = this.$_sp.MakeModel(response[1])
          badCoil.seqId = temp[0].seqId
          this.inventoryReceiptInfo.push(badCoil)
          this.refreshInventoryList()
          this.popupBadColi = false
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    async storeBadProcessing () {
      // 보관불량등의 원인으로 자체 폐기(불량수불 등록)
      const badParam = {
        발생일자: AppLib.getNow(),
        입출고구분: ConstDef.불량입고,
        불량원인: ConstDef.보관불량,
        품번: this.selectedRow.품번,
        거래처코드: this.selectedRow.입고업체,
        반품수량: this.editBadCoilOrgInfo.불량중량,
        구입가: this.selectedRow.가격,
        createid: this.userInfo.userName,
        updateid: this.userInfo.userName
      }
      this.isLoading = true
      await this.$_sp.runInsertSqlProc('불량수불', null, [badParam])
        .then(data => {
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      if (this.isLoading === false) {
        this.popupBadColi = false
        return
      }
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, [{ seqId: this.selectedRow.seqId, 스크랩처리: '보관불량' }])
        .then(data => {
          this.$snotify.info('재고관리 불량수불에서 확인할 수 있습니다.')
          this.popupBadColi = false
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSaveBadCoil (e) {
      if (!this.$refs.refFormBasCoil.instance.validate().isValid) return
      console.log(this.editBadCoilOrgInfo)
      if (this.editBadCoilOrgInfo.불량중량 > this.selectedRow.수량) {
        this.$snotify.info('불량중량이 입고중량보다 클수는 없습니다.')
        return
      }
      if (this.editBadCoilOrgInfo.불량중량 <= 0) {
        this.$snotify.info('불량중량은 0보다 커야 합니다.')
        return
      }
      this.$snotify.confirm(`불량 처리하시겠습니까?`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '불량처리',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.badCoilPrecessing()
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    // 용도변경
    onChangeCoilSize () {
      if (!this.$refs.refFormCoilSizeChange.instance.validate().isValid) return
      this.editCoilSizeChangeInfo.용변품번 = this.selectedCoilCode
      console.log(this.editCoilSizeChangeInfo)
      if (this.editCoilSizeChangeInfo.용변중량 > this.selectedRow.수량) {
        this.$snotify.info('용변중량이 입고중량보다 클수는 없습니다.')
        return
      }
      if (this.editCoilSizeChangeInfo.용변중량 <= 0) {
        this.$snotify.info('용변중량은 0보다 커야 합니다.')
        return
      }
      this.$snotify.confirm(`용도변경 처리하시겠습니까?`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '용도변경',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.onChangeCoilSizeProcessing()
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    async onChangeCoilSizeProcessing () {
      console.log(this.editCoilSizeChangeInfo)
      const param = {
        발생일자: AppLib.getNow(),
        마감일자: `${AppLib.getNow().substring(0, 7)}-01`,
        입고업체: this.selectedRow.입고업체,
        입출고구분: ConstDef.용변출고,
        품번: this.selectedRow.품번,
        수량: this.editCoilSizeChangeInfo.용변중량,
        코일수: this.selectedRow.코일수,
        운반비: 0,
        단가: this.selectedRow.가격,
        구입가: this.selectedRow.가격,
        발주번호: AppLib.uuidSequential(),
        lotNo: this.selectedRow.lotNo !== null ? `${this.selectedRow.lotNo} 용도변경` : '용도변경',
        createid: this.userInfo.userName,
        updateid: this.userInfo.userName,
        재질품번: this.selectedRow.재질품번
      }

      await this.$_sp.runInsertSqlProc('창고수불', null, [param])
        .then(data => {
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      const coilInfo = this.$_.findWhere(this.coilInfoList, { 품번: this.editCoilSizeChangeInfo.용변품번 })
      console.log(coilInfo)
      param.입출고구분 = ConstDef.용변입고
      param.재질품번 = param.품번 = this.editCoilSizeChangeInfo.용변품번
      await this.$_sp.runInsertSqlProc('창고수불', null, [param])
        .then(data => {
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })

      this.popupChangeCoilSize = false
      this.$snotify.info('현재월을 선택후 페이지 새로고침을 하여주세요.')
      if (this.$_.findWhere(this.외주사급코일정보, { 품번: param.품번 }) !== undefined) {
        param.입출고구분 = ConstDef.사급출고
        param.입고업체 = coilInfo.협력사코드
        this.$_sp.runInsertSqlProc('창고수불', null, [param])
          .then(data => {
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss"></style>
